import { css } from 'lit';

export const styles = css`:host{padding:.75rem .5rem;min-height:3rem}`;
